import { render, staticRenderFns } from "./Premier.vue?vue&type=template&id=6a34321d&"
import script from "./Premier.vue?vue&type=script&lang=js&"
export * from "./Premier.vue?vue&type=script&lang=js&"
import style0 from "./Premier.vue?vue&type=style&index=0&id=6a34321d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable,QDialog,QCard,QCardSection,QCardActions,QBtn,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTable,QDialog,QCard,QCardSection,QCardActions,QBtn})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
